export default __webpack_public_path__ + "static/media/330_dummy2016-streetfashion01-mobile-de.a07cb1f3.png";